import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useTranslation } from 'react-i18next';
import { API_STATUS } from '../../constants';
import ProgressBar from '../../components/ProgressBar';
import { updateUser, deleteUser } from '../../api/APIServices'
import { formatPhoneNumber } from '../../utils/utils';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

function Summary({ data, compliance }) {
    const { t } = useTranslation('global');
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [openEditUser, setOpenEditUser] = useState(false);
    const [open, setOpen] = useState(false);
    const [phone, setPhone] = useState(0);
    const [email, setEmail] = useState();
    const [educationPercentage, setEducationPercentage] = useState(0);
    const [exercisePercentage, setExercisePercentage] = useState(0);
    const { isUserDeleted } = useSelector((state) => state.user);

    const [summary, setSummary] = useState();

    useEffect(() => {
        if (data) {
            setSummary(data);
        }
        return () => {
            setSummary()
        }
    }, [data])

    useEffect(() => {
        if (compliance?.education) {
            const { completed, scheduled } = compliance.education;
            let eduPer = Math.floor((completed / scheduled) * 100)
            setEducationPercentage(eduPer)

        }

        if (compliance?.exercise) {
            const { completed, scheduled } = compliance.exercise;
            let exercisePer = Math.floor((completed / scheduled) * 100)
            setExercisePercentage(exercisePer)
        }

    }, [compliance]);

    const handlePhone = (e) => {
        const { value } = e.target
        setPhone(value)
    }

    const handleEmail = (e) => {
        const { value } = e.target
        setEmail(value);
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpenEditUser = () => {
        setOpenEditUser(true);
    };

    const handleCloseEditUser = () => {
        setPhone(summary.phone);
        setEmail(summary.email);
        setOpenEditUser(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let postData = { "userId": summary.userId, phone, email }
        dispatch(updateUser(postData));
    }

    const handleDeleteUser = (userId) => {
        dispatch(deleteUser(userId));
        setOpen(false);
        // navigate('/users')
    }

    useEffect(() => {
        if (isUserDeleted) {
            navigate('/users')
        }
    }, [isUserDeleted])


    return (
        <div className='summary-head'>
            <div className='profile-pic'>
                <Typography fontSize='1.5rem' sx={{ fontWeight: 'bold', color: '#003163' }}>
                    {summary?.firstName}  {summary?.lastName}
                </Typography>
            </div>
            <div className='profile-pic'>
                <Typography className='head-title'>{t('phone_number')}</Typography>
                <div className='head-text'>
                    {summary?.phone && formatPhoneNumber(summary?.phone)}
                </div>
            </div>
            <div className='profile-pic'>
                <Typography className='head-title'>{t('email')}</Typography>
                <div className='head-text'> {summary?.email}</div>
            </div>
            <div className='profile-pic'>
                <Typography className='head-title'>{t('dob')}</Typography>
                <div className='head-text'> {dayjs(summary?.dob).format('MM/DD/YYYY')}</div>
            </div>
            <div className='profile-pic'>
                <Typography className='head-title'>{t('education')}</Typography>
                <ProgressBar value={educationPercentage || 0} />
            </div>
            <div className='profile-pic'>
                <Typography className='head-title'>{t('exercise')}</Typography>
                <ProgressBar value={exercisePercentage || 0} />
            </div>
            <div className='profile-pic'>
                <Typography className='head-title'>{t('intake_date')}</Typography>
                <div className='head-text'>
                    {(summary?.intakeDate) ? dayjs(summary?.intakeDate).format('MM/DD/YYYY') : <span style={{ color: 'red' }}>
                        {t('pending')}</span>}
                </div>
            </div>
            <div className='profile-pic'>
                <Typography className='head-title'>{t('action')}</Typography>
                <div className='head-text' style={{ justifyContent: 'center', marginLeft: 20 }}>
                    <EditOutlinedIcon sx={{ marginRight: '5px' }} color='primary' onClick={handleClickOpenEditUser} />
                </div>
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t("delete_confirmation_message")}
                </DialogTitle>

                <DialogActions>
                    <Button onClick={() => handleDeleteUser(summary.userId)}>{t('yes')}</Button>
                    <Button color='primary' size='small' variant="contained" onClick={handleClose} autoFocus>
                        {t('no')}
                    </Button>
                </DialogActions>
            </Dialog>

            <form method='post'>
                <Dialog
                    open={openEditUser}
                    onClose={handleCloseEditUser}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        "& .MuiDialog-container": {
                            "& .MuiPaper-root": {
                                width: "100%",
                                maxWidth: "500px",
                                display: 'flex',
                                fontFamily: 'Open Sans'// Set your width here
                            },
                        },
                    }}
                >
                    <DialogTitle id="alert-dialog-title">
                        {t('update_user_details')}
                    </DialogTitle>
                    <DialogContent>
                        <div style={{ display: 'flex', marginBottom: '20px' }}>
                            <div style={{ marginRight: '5px', width: '50%' }}>
                                <Typography component={'span'} sx={{ fontSize: '12px' }}> {t('name')}</Typography>
                                <br />
                                <Typography>{summary?.firstName}  {summary?.lastName} </Typography>
                            </div>
                            <div>
                                <Typography component={'span'} sx={{ fontSize: '12px' }}> {t('dob')}</Typography>
                                <br />
                                <Typography>{summary?.dob}</Typography>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div style={{ marginRight: '5px' }}>
                                <TextField size='small'
                                    label={t('contact_number')}
                                    variant="outlined"
                                    defaultValue={summary?.phone}
                                    onChange={(e) => handlePhone(e)}
                                />
                            </div>
                            <div>
                                <TextField size='small'
                                    label={t('email')}
                                    variant="outlined"
                                    defaultValue={summary?.email}
                                    onChange={(e) => handleEmail(e)}
                                />
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button type='button' onClick={handleSubmit}> {t('save')}</Button>
                        <Button color='primary' size='small' variant="contained"
                            onClick={handleCloseEditUser} autoFocus>
                            {t('cancel')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </form>
        </div>
    )
}

export default Summary